module.exports = "../images/bass-fishing-ontario.jpg?v=591e891";